const cartModule = {
    add(productId, quantity) {
        $.ajax({
            url: "index.php?route=checkout/cart/add",
            type: "post",
            data: `product_id=${productId}&quantity=${quantity !== undefined ? quantity : 1}`,
            dataType: "json",
            beforeSend() {
                $("#cart > button, #cart_mobile > button").button("loading");
            },
            success(response) {
                $(".alert, .text-danger").remove();
                $("#cart > button, #cart_mobile > button").button("reset");

                if (response.redirect) {
                    location = response.redirect;
                    return;
                }

                $(".json_modal").remove();

                if (response.success) {
                    const html = `
                        <div id="modal-cart" class="modal top_modal json_modal">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-body-center" id="modal_body_style">
                                        <p id="modal_cart_sucess">${response.success}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;

                    $("body").append(html);
                    $("#modal-cart").modal("show");
                    $("#cart-total").html(response.total);
                    $(".rd-navbar-list-products").load("index.php?route=common/cart/info ul li");
                }
            },
            error(xhr) {
                alert(xhr.responseText);
            }
        });
    },
    update(key, quantity, source) {
        $.ajax({
            url: "index.php?route=checkout/cart/edit",
            type: "post",
            data: `key=${key}&quantity=${quantity !== undefined ? quantity : 1}`,
            dataType: "json",
            beforeSend() {
                $("#cart > button, #cart_mobile > button").button("loading");
            },
            success(response) {
                $("#cart > button, #cart_mobile > button").button("reset");
                $("#cart-total").html(response.total);

                if (source === "cart_header_update") {
                    location.reload();
                } else if (
                    getURLVar("route") === "checkout/cart" ||
                    getURLVar("route") === "checkout/checkout" ||
                    getURLVarAlias() === source
                ) {
                    location = "index.php?route=checkout/cart";
                } else {
                    $(".rd-navbar-list-products").load("index.php?route=common/cart/info ul li");
                }
            },
            error(xhr) {
                alert(xhr.responseText);
            }
        });
    },
    remove(key, source) {
        $.ajax({
            url: "index.php?route=checkout/cart/remove",
            type: "post",
            data: `key=${key}`,
            dataType: "json",
            beforeSend() {
                $("#cart .btn").button("loading");
            },
            success(response) {
                if (response.ga4) {
                    sendRemoveCartGa4(
                        response.remove_from_cart,
                        response.measurement_api_secret,
                        response.config_google_analytics
                    );
                }
                window.loadCartProducts();
                if (typeof window.loadQuantityItensCart === "function") {
                    window.loadQuantityItensCart();
                }
                $("#cart .btn").button("reset");

                if (source === "cart_header_remove") {
                    location.reload();
                } else {
                    $("#cart .btn-cart-header, #cart_mobile .btn-cart-header").html("Aguarde...");

                    if (
                        getURLVar("route") === "checkout/cart" ||
                        getURLVar("route") === "checkout/checkout" ||
                        getURLVarAlias() === source
                    ) {
                        location.reload();
                    } else {
                        cartModule.loadTotals();
                        cartModule.loadCartProducts();
                    }
                }
            },
            error(xhr) {
                alert(xhr.responseText);
            }
        });
    },
    removeOutfit(outfitId) {
        const keys = [];

        $(`.outfit-${outfitId} .product-resume`).each(function () {
            keys.push($(this).data("key"));
        });

        $.ajax({
            url: "index.php?route=checkout/cart/remove",
            type: "post",
            data: `key=${keys}&outfit=true`,
            dataType: "json",
            beforeSend() { },
            success() {
                location.reload();
            },
            error(xhr) {
                alert(xhr.responseText);
            }
        });
    },
    addcart(productId, quantity, stock, redirectToCart = false, refresh = false) {
        $.ajax({
            url: "index.php?route=checkout/cart/addcart",
            type: "post",
            data: `product_id=${productId}&quantity=${quantity !== undefined ? quantity : 1}&stock=${stock !== undefined ? stock : 1}`,
            dataType: "json",
            beforeSend(response) {
                if (response.stock_zero) {
                    $("#cart > button, #cart_mobile > button").button("loading");
                }
            },
            success(response) {
                if (redirectToCart) {
                    window.location.href = "/carrinho";
                    return;
                }

                $(".alert, .text-danger").remove();

                if (response.stock_zero) {
                    $("#cart > button, #cart_mobile > button").button("reset");
                    $(".json_modal").remove();
                }

                if (response.error_stock) {
                    const html = `
                    <div id="modal-cart" class="modal top_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="close">X</div>
                                    <p>${response.error_stock}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $(".top_modal").remove();
                    $("body").append(html);
                    $("#modal-cart").modal("show");
                }

                if (response.success) {
                    $("#modal-cart").remove();

                    const html = `
                    <div id="modal-cart" class="modal top_modal json_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').modal('hide');" class="close">X</div>
                                    <p id="modal_cart_sucess">${response.success}</p>
                                    <p>
                                        <div>
                                            <a href="javascript:void(0)" onclick="$('#modal-cart').modal('hide');" class="btn-continue-shopping btn-sm btn-secondary">
                                                Continuar Comprando
                                            </a>
                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $(`#stock_${response.product_id}`).html(response.stocknow);
                    $("body").append(html);

                    if (response.stock_zero) {
                        $("#modal-cart").modal("show");

                        if ($(".rd-navbar-cart .count-products").length) {
                            $(".rd-navbar-cart .count-products").html(response.total);
                        } else if ($("#cart-total").length) {
                            $("#cart-total").html(response.total);
                        }

                        $("#cart .cart-total-price, #cart_mobile .cart-total-price").html(response.total_price);
                        $("#cart-quantity").html(response.cart_total);
                        $(".menu_mobile_fixed_count_products").html(response.cart_total);
                        $(".rd-navbar-list-products").load("index.php?route=common/cart/info .rd-navbar-list-products > li");
                    }
                }

                if (refresh) {
                    $('#modal-cart').on('hidden.bs.modal', function () {
                        window.location.reload();
                    });
                }
            },
            error(xhr) {
                alert(xhr.responseText);
            }
        });
    },
    addCartOption(productId, quantity, options, redirectToCart = false) {
        $.ajax({
            url: "index.php?route=checkout/cart/add",
            type: "post",
            data: {
                product_id: productId,
                quantity: quantity,
                option: options,
                '__csrf': $('#__csrf').val()
            },
            dataType: "json",
            beforeSend(response) {
                if (response.stock_zero) {
                    $("#cart > button, #cart_mobile > button").button("loading");
                }
            },
            complete() {
                $(".product-btn-option").button("reset");
            },
            success(response) {
                if (redirectToCart && !(response.error || response.error_stock)) {
                    window.location.href = "/carrinho";
                    return;
                }

                if (response.error || response.error_stock) {
                    let errorMessage = "";

                    if (response.error_stock) {
                        errorMessage = response.error_stock;
                    } else if (response.error.option) {
                        for (const key in response.error.option) {
                            errorMessage += `<br>${response.error.option[key]}`;
                        }
                    } else if (response.error.recurring || response.error.product || response.error.empty_option) {
                        const firstErrorKey = Object.keys(response.error)[0];
                        errorMessage = firstErrorKey
                            ? response.error[firstErrorKey]
                            : "Houve um problema ao adicionar o produto ao carrinho!";
                    }

                    const html = `
                    <div id="modal-cart" class="modal top_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="close">X</div>
                                    <p>${errorMessage}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $(".top_modal").remove();
                    $("body").append(html);
                    $("#modal-cart").modal("show");
                } else {
                    $("#modal-cart").remove();

                    const html = `
                    <div id="modal-cart" class="modal top_modal json_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="close">X</div>
                                    <p id="modal_cart_sucess">${response.success}</p>
                                    <p>
                                        <div>
                                            <a href="javascript:void(0)" onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="btn-continue-shopping btn-sm btn-secondary">
                                                Continuar Comprando
                                            </a>
                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $("body").append(html);
                    $("#modal-cart").modal("show");
                    $("#cart .cart-total-price, #cart_mobile .cart-total-price").html(response.total_price);
                    $(".menu_mobile_fixed_count_products").html(response.total_quantity);
                    $("#cart-quantity").html(response.total_quantity);

                    if ($('.js-cart_dropdown').length) {
                        $("#cart .js-cart_dropdown").load("index.php?route=common/cart/info li");
                    } else {
                        $("#cart .rd-navbar-list-products").load("index.php?route=common/cart/info #cart .rd-navbar-list-products > li");
                    }
                }
            },
            error(xhr) {
                console.log(xhr.responseText);
            }
        });
    },
    addCartBudget(productId, quantity, stock) {
        $.ajax({
            url: "index.php?route=checkout/cart/addBudgetOrder",
            type: "post",
            data: `product_id=${productId}&quantity=${quantity !== undefined ? quantity : 1}&stock=${stock !== undefined ? stock : 1}`,
            dataType: "json",
            beforeSend(response) {
                if (response.stock_zero) {
                    $("#cart > button, #cart_mobile > button").button("loading");
                }
            },
            success(response) {
                console.log(response);

                $(".alert, .text-danger").remove();

                if (response.stock_zero) {
                    $("#cart > button, #cart_mobile > button").button("reset");
                    $(".json_modal").remove();
                }

                if (response.error_stock) {
                    const html = `
                    <div id="modal-cart" class="modal top_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="close">X</div>
                                    <p>${response.error_stock}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $(".top_modal").remove();
                    $("body").append(html);
                    $("#modal-cart").modal("show");
                }

                if (response.success) {
                    $("#modal-cart").remove();

                    const html = `
                    <div id="modal-cart" class="modal top_modal json_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="close">X</div>
                                    <p id="modal_cart_sucess">${response.success}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $(`#stock_${response.product_id}`).html(response.stocknow);
                    $("body").append(html);

                    if (response.stock_zero) {
                        $("#modal-cart").modal("show");
                        $("#cart-total").html(response.total);
                        $("#cart .cart-total-price, #cart_mobile .cart-total-price").html(response.total_price);
                        $("#cart-quantity").html(response.cart_total);
                        $(".rd-navbar-list-products").load("index.php?route=common/cart/info ul li");
                    }
                }
            },
            error(xhr) {
                alert(xhr.responseText);
            }
        });
    },
    addCartBudgetOption(productId, quantity, options) {
        $.ajax({
            url: "index.php?route=checkout/cart/addBudgetOrderOption",
            type: "post",
            data: {
                product_id: productId,
                quantity: quantity,
                option: options
            },
            dataType: "json",
            beforeSend(response) {
                if (response.stock_zero) {
                    $("#cart > button, #cart_mobile > button").button("reset");
                }
            },
            success(response) {
                if (response.error || response.error_stock) {
                    let errorMessage = "";

                    if (response.error_stock) {
                        errorMessage = response.error_stock;
                    } else if (response.error.option) {
                        for (const key in response.error.option) {
                            errorMessage += `<br>${response.error.option[key]}`;
                        }
                    } else if (response.error.recurring || response.error.product || response.error.empty_option) {
                        const firstErrorKey = Object.keys(response.error)[0];
                        errorMessage = firstErrorKey
                            ? response.error[firstErrorKey]
                            : "Houve um problema ao adicionar o produto ao carrinho!";
                    }

                    const html = `
                    <div id="modal-cart" class="modal top_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="close">X</div>
                                    <p>${errorMessage}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $(".top_modal").remove();
                    $("body").append(html);
                    $("#modal-cart").modal("show");
                } else {
                    $("#modal-cart").remove();

                    const html = `
                    <div id="modal-cart" class="modal top_modal json_modal">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body-center text-center" id="modal_body_style">
                                    <div onclick="$('#modal-cart').remove();$('.modal-backdrop').remove();$('body').removeClass('modal-open').removeAttr('style');" class="close">X</div>
                                    <p id="modal_cart_sucess">${response.success}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                    $("body").append(html);
                    $("#modal-cart").modal("show");

                    if (response.stock_zero) {
                        $("#cart-total").html(response.total_quantity);
                        $(".rd-navbar-list-products").load("index.php?route=common/cart/info ul li");
                    }
                }
            },
            error(xhr) {
                alert(xhr.responseText);
            }
        });
    },
    loadTotals() {
        $.ajax({
            url: `index.php?route=common/cart/cartTotal`,
            type: 'POST',
            success: function (total) {
                let new_value = new Intl.NumberFormat('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2
                }).format(total);

                $('.js-cart-total-price').html(`${new_value}`);
            },
            error: function (error) {
                console.log(error.responseText);
            }
        });
    },
    loadCartProducts() {
        $('#cart_dropdown, .js-cart_dropdown').load(`/index.php?route=common/cart/info&v=${generateNewVersion()}`, function () {
            if ($('#cart_dropdown, .js-cart_dropdown').find('input[type=number]').length) {
                $('input[type=number]').stepper({ labels: { up: "", down: "" } });
            }
        });
    }
};

function initCart() {
    $(document).on("click", ".js-remove-product", function () {
        const key = $(this).data("key");
        if (key) {
            cartModule.remove(key);
        }
    });

    window.cartModule = cartModule;
}

export { cartModule, initCart };